import React, { Component } from "react";
import { Link } from "react-router-dom";

import "../styles/components/Modules.css";

import offerShorttime from "../assets/icons-fleet/icon-offer-shortime.svg";
import offerLongtime from "../assets/icons-fleet/icon-offer-longtime.svg";
import offerSell from "../assets/icons-fleet/icon-offer-sell.svg";
import offerFleet from "../assets/icons-fleet/icon-offer-fleet.svg";

import $ from "jquery";

export default class ModuleRentalSale extends Component {
  componentDidMount() {
    document
      .getElementById("icon-offer-shorttime")
      .addEventListener("load", function() {
        var doc = this.getSVGDocument();
        var rect = doc.querySelector("#Warstwa_1");
        rect.setAttribute("fill", "black");
        rect.setAttribute("stroke", "white");
      });
    document
      .getElementById("icon-offer-longtime")
      .addEventListener("load", function() {
        var doc = this.getSVGDocument();
        var rect = doc.querySelector("#Warstwa_1");
        rect.setAttribute("fill", "black");
        rect.setAttribute("stroke", "white");
      });
    document
      .getElementById("icon-offer-sell")
      .addEventListener("load", function() {
        var doc = this.getSVGDocument();
        var rect = doc.querySelector("#Warstwa_1");
        rect.setAttribute("fill", "white");
        rect.setAttribute("stroke", "black");
      });

    $(".btn-long").hover(function() {
      $("#icon-offer-shorttime").removeClass("active");
      $("#icon-offer-longtime").addClass("active");
    });

    $(".btn-short").hover(function() {
      $("#icon-offer-shorttime").addClass("active");
      $("#icon-offer-longtime").removeClass("active");
    });

    $(".btn-fleet").hover(function() {
      $("#icon-offer-sell").removeClass("active");
      $("#icon-offer-fleet").addClass("active");
    });

    $(".btn-sell").hover(function() {
      $("#icon-offer-sell").addClass("active");
      $("#icon-offer-fleet").removeClass("active");
    });
  }

  render() {
    return (
      <div className="module-rental-sale container container-small">
        <div className="row">
          <div className="col-12 col-md-6 column column-left">
            <div className="inner">
              <div className="row">
                <div className="col-12 col-md-10 offset-md-2">
                  <h5>
                    {`01. `}
                    <span>{this.props.data.categories[0].titleMain}</span>
                  </h5>
                  <p>{this.props.data.categories[0].titleSub}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-8 offset-md-2 icon-offer-wrapper text-center">
                  <object
                    id="icon-offer-longtime"
                    className="offer-icon active"
                    data={offerLongtime}
                    type="image/svg+xml"
                  >
                    <img src={offerLongtime} alt="rent icon" />
                  </object>
                  <object
                    id="icon-offer-shorttime"
                    className="offer-icon "
                    data={offerShorttime}
                    type="image/svg+xml"
                  >
                    <img src={offerShorttime} alt="rent icon" />
                  </object>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-8 offset-md-2">
                  <Link
                    className="btn-link btn-link--primary btn-long"
                    to="/oferta/wynajem-dlugookresowy"
                  >
                    Wynajem długoterminowy
                  </Link>
                  <br />
                  <Link
                    className="btn-link btn-link--primary btn-short"
                    to="/oferta/wynajem-krotkookresowy"
                  >
                    Wynajem krótkoterminowy
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 column column-right">
            <div className="inner">
              <div className="row">
                <div className="col-12 col-md-10 offset-md-2">
                  <h5>
                    {`02. `}
                    <span>{this.props.data.categories[1].titleMain}</span>
                  </h5>
                  <p>{this.props.data.categories[1].titleSub}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-8 offset-md-2 icon-offer-wrapper text-center">
                  <object
                    id="icon-offer-sell"
                    className="offer-icon active"
                    data={offerSell}
                    type="image/svg+xml"
                  >
                    <img src={offerSell} alt="rent icon" />
                  </object>
                  <object
                    id="icon-offer-fleet"
                    className="offer-icon"
                    data={offerFleet}
                    type="image/svg+xml"
                  >
                    <img src={offerFleet} alt="rent icon" />
                  </object>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-8 offset-md-2">
                  <Link
                    className="btn-link btn-link--primary btn-sell"
                    to="/oferta/sprzedaz"
                  >
                    Zakup
                  </Link>
                  <br />
                  <Link
                    className="btn-link btn-link--primary btn-fleet"
                    to="/oferta/obsluga-flot"
                  >
                    Obsługa flot
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
